<template>
    <!-- 头像组件 -->
    <el-avatar 
    :size="size" 
    :icon="icon"
    :shape="shape"
    :src="src"
    :srcSet="srcSet"
    :alt="alt"
    :fit="fit"
    @error="error"
    >
        <slot></slot>
    </el-avatar>
</template>
<script>
export default {
    name:"VelAvatar",
    props:{
        size:[Number,String],
        icon:String,
        shape:String,
        src:String,
        srcSet:String,
        alt:String,
        fit:String,
    },
    data() {
        return {
            
        };
    },
    methods: {
        error(e){
            this.$emit('error',e)
        }
    }
}
</script>